<template>
<div class="form-submission-card">
    <submission-title :form_status="snag_list.form_status ?? form_submission.form_status" />

    <submission-subtitle
        :signature="snag_list.signature ?? form_submission.signature"
        :form_status="snag_list.form_status ?? form_submission.form_status"
        :pdf_mode="pdf_mode"
        @open-signature="openSignature"
    />

    <show-signature-modal
        :signature="snag_list.signature ?? form_submission.signature"
        ref="signature_modal"
    />

    <gallery-view-component
        v-if="form_submission.photos.length"
        class="form-submission-card-content-child"
        :photos="form_submission.photos"
    />

    <response-text
        v-for="(value, label) in fields"
        :key="`response:${label}`"
        :question="label"
        :answer="value"
    />
</div>
</template>

<script>
import SubmissionTitle from "../submissions/SubmissionTitle";
import SubmissionSubtitle from "../submissions/SubmissionSubtitle";
import GalleryViewComponent from "../general_components/GalleryViewComponent";
import ShowSignatureModal from "../modals/ShowSignatureModal";
import ResponseText from "./responses/ResponseText.vue";

export default {
    name: "SnagListSubmission",
    components: {
        ShowSignatureModal,
        GalleryViewComponent,
        SubmissionTitle,
        SubmissionSubtitle,
        ResponseText
    },
    props: {
        form_submission: Object,
        snag_list: Object,
        pdf_mode: Boolean,
    },
    computed: {
        fields: function () {
            return {
                'Ref No.': this.snag_list?.ticket_no ?? '',
                'Date & Time': this.snag_list?.date_opened_formatted ?? '',
                'Drawing No.': this.snag_list?.drawing_number ?? '',
                'Assignee': this.snag_list?.assigned_user_name ?? '',
                'Contractor': this.snag_list?.contractor ?? '',
                'Location': this.snag_list?.location ?? '',
                'Description': this.snag_list?.description ?? '',
            }
        }
    },
    methods: {
        openSignature() {
            this.$refs.signature_modal.open();
        },
    },
}
</script>
